import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getLatestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = getLatestUpdates(8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">最近更新</h2>
            <p className="text-sm text-foreground-500 mt-2">最新上线的韩国漫画章节</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}